<template>
    <div class="mainwrap">
        <div class="shop-wrapper">

        <div v-if=" orderSystem == '1'" >

            <div class="tune-widget-mainbar">
                <div class="tune-widget-mainbar-l">
                           <logo-link :logo="img1" :link="siteLinkout"/>
                    <!-- <img :src="img1" class="header-image" alt="start image"> -->
                </div>
                <div class="tune-widget-mainbar-m">{{ $t("rica_shop") }}</div>
                <div class="tune-widget-mainbar-r"> &nbsp;</div>
            </div>

            <div class="shop-results">
                <div class="center-widget">


                    <div v-if="shoppingCart.length > 0">
                        
                        <div class="main-header" >{{ $t("your_cart") }}</div>
                        <div class="shop-cart-list">

                            <div  class="tuning-results-row">
                                <div class="tuning-product-col shop-item-col1" >&nbsp;</div>
                                <div class="tuning-product-header shop-item-col2" >{{ $t("description") }}</div>
                                <div class="tuning-product-header shop-item-col3 hideMobile" >{{ $t("quantity") }}</div>
                                <div class="tuning-product-header shop-item-col4" style="">{{ $t("price") }}</div>
                            </div>
                            <div class="shop-item-row" v-for="product in shoppingCart"  v-bind:key="product.ProductID" >

                                <div class="shop-item-col1"><img :src=product.ProductImageThumbURL style="width:70px;display:inline-block;"></div>
                                <div class="shop-item-col2">
                                    <div style="float:left;width:100%;padding-bottom:5px;">{{product.ProductName}} - {{product.Category}} </div>
                                    <div class="hideDesktop">
                                        <div class="rica-shop-stepper-bg">
                                        <div class="rica-shop-stepper-but" @click="decreaseItemAmount(product)"> - </div>
                                        <div class="rica-shop-stepper-num"> {{ product.amount }} </div>
                                        <div class="rica-shop-stepper-but" @click="increaseItemAmount(product)"> + </div>
                                    </div>
                                    <div class="rica-shop-spacing"></div>
                                    <div class="rica-removebasket"  @click="removeFromCart(product.ProductID)"><i class="fa fa-close"></i></div>
                                    
                                        
                                    </div>

                                </div>
                                <div class="shop-item-col3 hideMobile">  
                                    <div class="rica-shop-stepper-bg">
                                        <div class="rica-shop-stepper-but" @click="decreaseItemAmount(product)"> - </div>
                                        <div class="rica-shop-stepper-num"> {{ product.amount }} </div>
                                        <div class="rica-shop-stepper-but" @click="increaseItemAmount(product)"> + </div>
                                    </div>
                                    <div class="rica-shop-spacing"></div>
                                    <div class="rica-removebasket"  @click="removeFromCart(product.ProductID)"><i class="fa fa-close"></i></div>
                                    
                                </div>
                                <div class="shop-item-col4">

                                    <div v-if="product.DiscountDescription ">
                                        
                                    </div>
                                    
                                    
                                    
                                    <div v-if="product.ProductCode == '50p' && this.hasStagingProduct">
                                        <div style="float:left;width:100%;text-decoration:line-through;">&euro; {{ formatPrice(custom_fixUglyPrice(product.Price)*product.amount)}}</div>

                                            <div class="discount_price_red" style="float:left;width:100%;">&euro; {{ formatPrice(custom_fixUglyPrice(product.Price)/2*product.amount)  }}</div>
                                    </div>
                                    <div v-else>
                                        <div v-if="product.DiscountDescription ">
                                            <div style="float:left;width:100%;text-decoration:line-through;">&euro; {{ formatPrice(custom_fixUglyPrice(product.Price)*product.amount)}}</div>
                                            <div class="discount_price_red" style="float:left;width:100%;">&euro; {{ formatPrice(custom_fixUglyPrice(extractDiscount(product.DiscountDescription))*product.amount)  }}</div>
                                        </div>
                                        <div v-else>
                                        <div style="float:left;width:100%;">&euro; {{ formatPrice(custom_fixUglyPrice(product.Price)*product.amount)}}</div>
                                    </div>
                                    </div>

                                </div>
        
                            </div>
                        </div>
                        
                        <!-- <div class="tuning-results-row" ></div> -->

                        <div class="shop-cart-list" style="width:100%;">
                            <div class="shop-row-split" style="text-align:left;">
                                <div class="shop-total-row" v-if="hasPromocode == 1">
                                    <!-- <div class="checkout-col-field" style="width:30%;">{{ $t("discount_code") }}</div> -->
                                    <div class="checkout-col-field" style="width:50%;">
                                        <input type="text" class="promo-input" id="discount_code" name="discount_code" :placeholder="enterPromoCode">
                                        <div class="promo-input-button" id="update_price">+</div>
                                    </div>
                                    <div class="shop-item-col-title" style="width:10%;text-align:right;"></div>
                                </div>&nbsp;
                            </div>

                            <div class="shop-row-split" style="text-align:left;">
                                <div class="shop-total-row" >
                                    <div class="shop-summary-col1" style="">{{ $t("subtotal") }}</div>
                                    <div class="shop-summary-col2" style="">&euro; {{ formatPrice(cartTotal) }}</div>
                                </div>
                   
                                <div class="shop-total-row" v-if="extraDiscount['amount'] > 0">
                                    <div class="shop-summary-col1" style="">{{ extraDiscount["name"][locale] }}</div>
                                    <div class="shop-summary-col2" style="">- &euro; {{ formatPrice(extraDiscount["amount"]) }}</div>
                                </div>

                                <div class="shop-total-row" ><hr /></div>
                                <div class="shop-total-row" >
                                    <div class="shop-summary-col1 bold" style="">{{ $t("total_incvat")}}</div>
                                    <div class="shop-summary-col2 bold" style="">&euro; {{ formatPrice(grandTotal) }}</div>
                                    <div class="shop-summary-col1 " style="width:100%;text-align:left;">{{ $t("total_exship_text") }}</div>
                                    <div class="shop-summary-col2 " style=""></div>                                    
                                </div>
                                <div class="shop-total-row" ></div>

                                <div class="generic-form-row" >
                                    <div class="two-button-left-ar">
                                    <div class="tune-action-button" @click="gotoCheckout()">{{ $t("goto_checkout") }}</div>
                                    </div>
                                    <div class="two-button-right-ar">
                                        <div class="tune-action-button" @click="this.$router.push('/')">{{ $t("continue_shopping") }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    
                    </div>
                    <div v-else>
                        <div class="generic-form-row" >&nbsp;</div>
                        <div class="generic-form-row" >{{ $t("cart_empty") }}</div>
                        <div class="generic-form-row" >&nbsp;</div>
                        <div class="" style="text-align:center;padding:30px;">
                            <div class="tune-action-button" style="width:155px;display:inline-block;" @click="this.$router.push('/')">{{ $t("back_to_home") }}</div>
                        </div>                 
                    </div>
                </div>
            </div>

        </div>
        <div v-else>
            Order system not active
        </div>
        </div>
    </div>
</template>

<script>

const methods= {
    removeFromCart(pid) {
        this.$store.commit("removeProduct", pid);
        return true
    },
    changelanguage: function changelanguage(rowId, event) {
        var newLocale = event.target.value;
            this.$i18n.locale = newLocale;
    },
    custom_fixUglyPrice: function(price) {
	    // in cents/units!
        if(price == "" || price == undefined) {
            price = "0";
        }
        var priceInt = price.replace("+ VAT","");
	    priceInt = priceInt.replace("€","");
        priceInt = priceInt.split(" ")[0];
    	return priceInt;
    },
    formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    gotoCheckout() {
     this.$router.push("checkout")
    },
    decreaseItemAmount(item) {
        var cc = this.$store.state.shoppingCart;
        for(var i=0 ; i < cc.length ; i++) {
            if(cc[i]["ProductID"] == item.ProductID) {
                cc.splice(i, 1);
                    this.$store.commit("removeProductNumber", i);
                return true;;
            }
        }
    },
    increaseItemAmount(item) {
        var cc = this.$store.state.shoppingCart;
        for(var i=0 ; i < cc.length ; i++) {
            if(cc[i]["ProductID"] == item.ProductID) {
                // cc.push(cc[i]);
                this.$store.commit("addProduct", item);                
                return true;;
            }
        }
    }

}
export default {
    data() {
        this.$i18n.locale =  this.$store.state.curLanguage
        var curLocale = this.$i18n.locale;
        var shippingTotal = 0;
        //  var grandTotal = grandTotal;
         var discountName = "";
         var discount_code = this.$t("discount_code");
         var enterPromoCode = this.$t("enter_promo_code");
         
         var hasPromocode = false;
         var hasStagingProduct = false;
        return {
            img1:require('./../assets/header-logo.png'),            
            shippingTotal,
            // grandTotal,
            discount_code,
            discountName,
            hasPromocode,
            hasStagingProduct,
            enterPromoCode,
            locale:curLocale
        }

    },
    methods: methods,
    mounted() {
 

    },
    computed: {
        orderSystem: function () {
            return this.$store.state.orderSystem;
        }

    },
    components: {
        'bottom-bar': require('@/components/BottomBar.vue').default,
        'logo-link': require('@/components/LogoLink.vue').default,
    }
}
</script>